import type { Colour, PartNo, PropertyConfigCode, SmartNumberMapping } from "@/features/sub-families/types";
import { getPartNumberFromDescriptor } from "@/features/sub-families/utils/parts.ts";
import type { Nullable } from "@/types";
import { typedObjectEntries } from "@/utils/types.ts";

export const formatColour = (colour: Colour) => colour.name;

export const getSelectedFinishingColours = (smartNumberMapping: Nullable<SmartNumberMapping>) => {
    return typedObjectEntries(smartNumberMapping ?? {}).reduce<Record<PartNo, PropertyConfigCode>>(
        (acc, [descriptor, configCode]) => {
            const partNo = getPartNumberFromDescriptor(descriptor);
            if (partNo !== null) acc[partNo] = configCode;

            return acc;
        },
        {},
    );
};
